<div class="page-not-found-wrapper">
    <h1>
        Oops, this page doesn't exist!
    </h1>
    <button mat-raised-button color="primary" [routerLink]="['/']">
        <mat-icon aria-hidden="false" aria-label="home icon" fontIcon="home"></mat-icon>
        Home
    </button>
</div>